import React, { useState } from 'react'
import s from '../index.module.css'
import Modal from '../../../../components/modal-v2/modal'
import { ArrowRightCircle } from '../../../../svg/arrow_right_circle'
import { ChatFill } from '../../../../svg/chat_fill'
import { Medal } from '../../../../svg/medal'
import {
  PREFIX_REPOSITORY,
  POSTFIX_REPOSITORY,
} from '../../../../constants/URLs'
import { withPrefix } from 'gatsby'
import { dataModal } from '../../../../components/sobre-prima-afp/responsabilidad-social/premio-excelencia-prima-afp/data'

const defaultState = {
  showModal: false,
  index: 0,
}

const Content = () => {
  const [state, setState] = useState(defaultState)

  const openModal = (isModal, i) => {
    setState({
      showModal: isModal,
      index: i,
    })
  }

  return (
    <>
      <section className="tw-mt-2 tw-pt-12 tw-pt-16@lg bg-white">
        <div className={'containerWrap'}>
          <div>
            <div
              className={`tw-pt-2@lg center font-family-primary fw-4 tw-f-18 tw-f-18@lg ${s.elementMarginBottom}`}
            >
              Premiaciones Prima
            </div>
            <h3 className="font-family-secondary c-gray--4 fw-7 tw-f-20 tw-f-24@lg tw-mb-4 tw-mb-6@lg center">
              Premio excelencia Prima AFP
            </h3>
            <div className="flex justify-center tw-mb-8 tw-mb-10@lg">
              <p className="w-100 w-60@lg font-family-primary fw-4 tw-f-16 tw-f-16@lg center">
                En Prima AFP creemos que para ayudar a construir un país cada
                vez mejor, es importante incentivar la búsqueda de la excelencia
                en nuestros jóvenes profesionales. Es por ello que cada año
                llevamos a cabo la edición del Premio Excelencia Prima AFP, el
                cual reconoce el esfuerzo y excepcional rendimiento académico de
                los dos mejores alumnos de las carreras de Administración,
                Economía e Ingeniería Industrial de las principales
                universidades del país.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="tw-mt-5 tw-mt-10@lg tw-pt-5 tw-pt-10@lg bg-white center left@lg">
        <div className={'containerWrap'}>
          <div className={`flex direction-column direction-row@lg`}>
            <div className={`w-100 w-50@lg center left@lg`}>
              <img
                src={withPrefix('/images/man-climbing.svg')}
                alt=""
                className={`${s.imagenBox1}`}
              />
            </div>

            <div
              className={`w-100 w-50@lg tw-mb-8 tw-mb-0@lg tw-pt-0 tw-pt-5@lg`}
            >
              <p className="font-family-primary c-gray--4 fw-0 tw-f-16 tw-f-16@lg tw-mb-4 tw-mb-4@lg left">
                Cada año, los ganadores de este premio reciben un homenaje
                público y tienen la posibilidad de postular a becas de estudio
                para maestrías y post grado, otorgadas por instituciones
                educativas líderes del Perú. Asimismo, los premiados tienen la
                posibilidad de postular a puestos de trabajo en importantes
                empresas que apoyan esta iniciativa.
              </p>

              <div className="flex items-center">
                <div className="brad-4 border border-2 border-turquoise-2 tw-p-6 tw-pr-12 tw-pr-16@lg bg-white">
                  <p className="font-family-primary c-gray--4 fw-4 tw-f-18 tw-f-18@lg left">
                    De esta forma Prima AFP busca incentivar la excelencia
                    académica en los jóvenes universitarios, convencida de que
                    un país con mejores profesionales tiene el camino seguro
                    para su desarrollo.
                  </p>
                </div>
                <div
                  className={`brad-pill border border-2 border-turquoise-2 tw-p-2 tw-pr-3 tw-pb-3 bg-white ${s.iconArrow}`}
                >
                  <Medal height={40} width={40} fill="#00CCCC" />
                </div>
              </div>

              <div
                className={`brad-4 bg-yellow-1 tw-p-4 tw-pb-2 font-family-primary tw-f-16 tw-f-16@lg tw-mt-8 tw-mt-6@lg`}
              >
                <div className={`flex`}>
                  <div className={`tw-mr-2`}>
                    <ChatFill fill={'#FFCD00'} />
                  </div>
                  <div className="left">
                    <p>
                      En sus 21 años de creación, el Premio Excelencia ha
                      reconocido a más de 2,500 egresados universitarios.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="tw-mt-2 tw-pt-12 tw-pt-16@lg bg-white">
        <div className={'containerWrap'}>
          <div>
            <div
              className={`tw-pt-2@lg center font-family-primary fw-4 tw-f-18 tw-f-18@lg ${s.elementMarginBottom}`}
            >
              Premiaciones Prima
            </div>
            <h3 className="font-family-secondary c-gray--4 fw-7 tw-f-20 tw-f-24@lg tw-mb-4 tw-mb-6@lg center">
              Compromiso con el Adulto Mayor
            </h3>
            <div className="flex justify-center tw-mb-8 tw-mb-10@lg">
              <p className="w-100 w-60@lg font-family-primary fw-4 tw-f-16 tw-f-16@lg center">
                Uno de nuestros objetivos es revalorar la imagen del Adulto
                Mayor, presentándolo como una persona activa y experimentada que
                puede seguir aportando a la sociedad y al desarrollo del país
                desde diferentes ámbitos, siendo a la vez un ejemplo a seguir
                por las presentes y futuras generaciones.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="tw-mt-5 tw-mt-10@lg tw-pt-12 tw-pt-20@lg bg-turquoise-1 center left@lg">
        <div className={'containerWrap'}>
          <div className={`flex direction-column direction-row@lg`}>
            <div className={`w-100 w-50@lg order-2 order-1@lg center left@lg`}>
              <img
                src={withPrefix('/images/woman-old-chair-and-flower.svg')}
                alt=""
                className={`${s.imagenBox1}`}
              />
            </div>

            <div
              className={`w-100 w-50@lg order-1 order-2@lg tw-mb-8 tw-mb-0@lg tw-pt-0 tw-pt-20@lg`}
            >
              <h4 className="font-family-secondary c-gray--4 fw-7 tw-f-20 tw-f-24@lg tw-mb-2 tw-mb-4@lg">
                Premio Adulto Mayor Prima AFP
              </h4>
              <p className="font-family-primary c-gray--4 fw-0 tw-f-16 tw-f-16@lg tw-mb-4 tw-mb-4@lg center left@lg">
                Desde el año 2007 este premio reconoce a los adultos destacados
                y los adultos mayores emprendedores, los cuales son elegidos por
                un jurado calificador conformado por reconocidas personalidades
                del ámbito académico, social, de investigación y periodístico.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className={`bg-white tw-mt-5 tw-mt-10@lg tw-pt-10 tw-pt-18@lg`}>
        <div className={`containerWrap`}>
          <div className={`flex direction-column direction-row@lg tw-mb-20`}>
            <div
              className={`w-100 w-50@lg order-1 order-2@lg tw-mb-6 tw-mb-0@lg`}
            >
              <img
                src={withPrefix('/images/trophy.svg')}
                alt=""
                className={`${s.imagenBox4} db m-auto@lg`}
              />
            </div>

            <div className={`w-100 w-50@lg order-2 order-1@lg`}>
              <h4 className="font-family-secondary c-gray--4 fw-7 tw-f-20 tw-f-20@lg tw-mt-0@lg tw-mb-2 tw-mb-4@lg tw-pt-0 tw-pt-10@lg left flex">
                <ArrowRightCircle fill={'#04A6A2'} className={`tw-mr-2`} />
                <span>
                  Premio Reconocimiento al Adulto Mayor Destacado Prima AFP
                </span>
              </h4>
              <div className="font-family-primary c-gray--4 tw-f-16 tw-f-16@lg left tw-pl-8@lg">
                <p>
                  Reconoce a aquellos adultos mayores que se encuentran en plena
                  actividad y que se distinguen por una trayectoria de vida en
                  la cual han brindado valiosos aportes a la sociedad,
                  cultivando valores éticos y morales, constituyendo un
                  testimonio vivo de compromiso y responsabilidad social y, por
                  tanto, un ejemplo para las nuevas generaciones. Este premio se
                  otorga en los siguientes campos: empresarial, intelectual,
                  artístico y de servicio social.
                </p>
              </div>
            </div>
          </div>

          <div className={`flex direction-column direction-row@lg tw-mb-20`}>
            <div
              className={`w-100 w-50@lg order-1 order-1@lg flex@lg items-center justify-center`}
            >
              <img
                src={withPrefix('/images/medal.svg')}
                alt=""
                className={`${s.imagenBox4} db m-auto@lg`}
              />
            </div>

            <div className={`w-100 w-50@lg order-2 order-2@lg`}>
              <h4 className="font-family-secondary c-gray--4 fw-7 tw-f-20 tw-f-20@lg tw-mt-0@lg tw-mb-2 tw-mb-4@lg tw-pt-0 tw-pt-10@lg left flex">
                <ArrowRightCircle fill={'#04A6A2'} className={`tw-mr-2`} />
                <span>Premio Adulto Mayor Emprendedor Prima AFP</span>
              </h4>
              <div className="font-family-primary c-gray--4 tw-f-16 tw-f-16@lg left tw-pl-8@lg tw-pr-4@lg">
                <p>
                  Reconoce a aquellos adultos mayores que se atrevieron a
                  iniciar una actividad distinta en esta nueva etapa de su vida,
                  emprendiendo un negocio o constituyendo una empresa,
                  demostrando así que forman parte del capital humano de nuestro
                  país por su potencial creativo y de generación de valor para
                  el desarrollo.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="tw-mt-5 tw-mt-10@lg tw-mb-5 tw-mb-10@lg bg-white">
        <div className={'containerWrap'}>
          <div>
            <h4 className="font-family-secondary c-gray--4 fw-7 tw-f-20 tw-f-20@lg tw-mb-4 tw-mb-6@lg left">
              Bases del concurso
            </h4>
            <div className="tw-mb-8 tw-mb-10@lg">
              <p className="font-family-primary fw-4 tw-f-16 tw-f-16@lg left">
                Para ver las bases del Premio Reconocimiento al Adulto Mayor
                Destacado haz Click{' '}
                <a
                  className="c-orange-0 b underline"
                  target="_blank"
                  rel="noopener noreferrer"
                  href={
                    PREFIX_REPOSITORY +
                    '2020/pdf/' +
                    'Bases_PAMD_PrimaAFP_2018.pdf' +
                    POSTFIX_REPOSITORY
                  }
                >
                  Aquí.
                </a>
              </p>
            </div>

            <h4 className="font-family-secondary c-gray--4 fw-7 tw-f-20 tw-f-20@lg tw-mb-4 tw-mb-6@lg left">
              Formulario de postulación
            </h4>
            <div className="tw-mb-8 tw-mb-10@lg">
              <p className="font-family-primary fw-4 tw-f-16 tw-f-16@lg left">
                Para descargar el formulario de postulación del Concurso Premio
                Reconocimiento al Adulto Mayor Destacado haz Click{' '}
                <a
                  className="c-orange-0 b underline"
                  target="_blank"
                  rel="noopener noreferrer"
                  href={
                    PREFIX_REPOSITORY +
                    '2020/' +
                    'Formulario_adulto_mayor_destacado_2018.doc' +
                    POSTFIX_REPOSITORY
                  }
                >
                  Aquí.
                </a>
              </p>
            </div>

            <h4 className="font-family-secondary c-gray--4 fw-7 tw-f-20 tw-f-20@lg tw-mb-4 tw-mb-6@lg left">
              Ganadores del concurso
            </h4>
            <div
              className={`w-100 flex direction-column direction-row@lg c-orange-0 b underline tw-mb-8 tw-mb-16@lg`}
            >
              <div className={`w-100 w-20@lg`}>
                <ul className={`m-0 p-0`}>
                  <li
                    className={`font-family-primary tw-f-16 tw-f-16@lg tw-mb-2 cursor-pointer ${s.listPanel}`}
                    onClick={() => openModal(true, 0)}
                  >
                    Edición 2007
                  </li>
                  <li
                    className={`font-family-primary tw-f-16 tw-f-16@lg tw-mb-2 cursor-pointer ${s.listPanel}`}
                    onClick={() => openModal(true, 5)}
                  >
                    Edición 2012
                  </li>
                  <li
                    className={`font-family-primary tw-f-16 tw-f-16@lg tw-mb-2 cursor-pointer ${s.listPanel}`}
                    onClick={() => openModal(true, 10)}
                  >
                    Edición 2017
                  </li>
                </ul>
              </div>

              <div className={`w-100 w-20@lg tw-mr-0 tw-mr-5@lg`}>
                <ul className={`m-0 p-0`}>
                  <li
                    className={`font-family-primary tw-f-16 tw-f-16@lg tw-mb-2 cursor-pointer ${s.listPanel}`}
                    onClick={() => openModal(true, 1)}
                  >
                    Edición 2008
                  </li>
                  <li
                    className={`font-family-primary tw-f-16 tw-f-16@lg tw-mb-2 cursor-pointer ${s.listPanel}`}
                    onClick={() => openModal(true, 6)}
                  >
                    Edición 2013
                  </li>
                </ul>
              </div>

              <div className={`w-100 w-20@lg tw-mr-0 tw-mr-5@lg`}>
                <ul className={`m-0 p-0`}>
                  <li
                    className={`font-family-primary tw-f-16 tw-f-16@lg tw-mb-2 cursor-pointer ${s.listPanel}`}
                    onClick={() => openModal(true, 2)}
                  >
                    Edición 2009
                  </li>
                  <li
                    className={`font-family-primary tw-f-16 tw-f-16@lg tw-mb-2 cursor-pointer ${s.listPanel}`}
                    onClick={() => openModal(true, 7)}
                  >
                    Edición 2014
                  </li>
                </ul>
              </div>

              <div className={`w-100 w-20@lg`}>
                <ul className={`m-0 p-0`}>
                  <li
                    className={`font-family-primary tw-f-16 tw-f-16@lg tw-mb-2 cursor-pointer ${s.listPanel}`}
                    onClick={() => openModal(true, 3)}
                  >
                    Edición 2010
                  </li>
                  <li
                    className={`font-family-primary tw-f-16 tw-f-16@lg tw-mb-2 cursor-pointer ${s.listPanel}`}
                    onClick={() => openModal(true, 8)}
                  >
                    Edición 2015
                  </li>
                </ul>
              </div>

              <div className={`w-100 w-20@lg`}>
                <ul className={`m-0 p-0`}>
                  <li
                    className={`font-family-primary tw-f-16 tw-f-16@lg tw-mb-2 cursor-pointer ${s.listPanel}`}
                    onClick={() => openModal(true, 4)}
                  >
                    Edición 2011
                  </li>
                  <li
                    className={`font-family-primary tw-f-16 tw-f-16@lg tw-mb-2 cursor-pointer ${s.listPanel}`}
                    onClick={() => openModal(true, 9)}
                  >
                    Edición 2016
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {state.showModal && (
        <Modal
          size={'medium'}
          icoCloseColor={'#ff4f00'}
          onClose={() => openModal(false)}
        >
          {dataModal[state.index].content}
        </Modal>
      )}
    </>
  )
}

export default Content
